var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nut-switch",class:[{ 'nut-switch-active': _vm.isActive }, 'nut-switch-' + _vm.size, { 'nut-switch-disabled': _vm.disabled }],on:{"click":_vm.toggle}},[_c('div',{staticClass:"nut-switch-btn"})])}
var staticRenderFns = []

export { render, staticRenderFns }